import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesProductUsageGuides } from "../../constants";
import { UsageGuide } from "../../productUsageGuides.types";
import { CreateUsageGuideFaqItemRequestBody } from "./createUsageGuideFaqItem.types";

export const requestCreateUsageGuideFaqItem = async ({
  guideId,
  ...body
}: CreateUsageGuideFaqItemRequestBody): Promise<UsageGuide> => {
  // Appended to the end of the list — `sortOrder` is assigned by the backend.
  // The whole updated guide comes back, so there is nothing to refetch.
  return await instance.post(
    buildUrl(ApiRoutesProductUsageGuides.Guides, guideId, "faq"),
    body
  );
};
